import type { FaireProductEntity } from "../../entity_types/product";

export const p_x3qnc3xrmz: FaireProductEntity = {
  token: "p_x3qnc3xrmz",
  type: "product",
  name: "Newborn Bamboo Gown & Hat Set",
  brandToken: "b_djzznyju1u",
  brandName: "Little Joy Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/2cfb7ea848c8e54e040c584a5d36aa0999a9254607006746d096a2777c9d140e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/562b457d7ebfd5f5320d6cc1d6b73c235b621eb445f1839859144ab933309a77.jpeg",
    "https://cdn.faire.com/fastly/c082b251167141111619cf6c275e11d4f6e36dfcd22e07133c82ff7037d9ab46.jpeg",
    "https://cdn.faire.com/fastly/12e0f1f0e43e9bf467b19d1ffdd14316398692e22630173d0fd7f48cfad74b45.jpeg",
    "https://cdn.faire.com/fastly/3a08209df98926b16e85eb00acb1b79576cdec0b994e36b924470931349a4e4d.jpeg",
    "https://cdn.faire.com/fastly/0d5f374ea94e715b35a45949e127657c9a440b962d32e9739ed5b1cf27aeb8a2.jpeg",
    "https://cdn.faire.com/fastly/736843cf8ba5bff2f5d2a6c9a588f428d45d82e6983946fb4fd94b89a639068c.jpeg",
    "https://cdn.faire.com/fastly/b97ba4ea22b71e1a847ccaf23fc0062f3b7d4c8afa47c244a3cfa63e9d74e822.jpeg",
    "https://cdn.faire.com/fastly/154d6888dd2ba9a06296ab4c552f218726a719902b1a64c1b783ff97b4f68827.jpeg",
    "https://cdn.faire.com/fastly/e8f5d6549e2f9e09dcc7461d6af00bcefd7978bbb238cd7cfd5475c8be6cb7b7.jpeg",
    "https://cdn.faire.com/fastly/417b32c52456ebb2610a05ada6ce221d987a1a81bc47c6a6278612b7ec756810.jpeg",
  ],
  priceDollars: 15,
  description:
    "\nWrap your little one in comfort and style with our Newborn Bamboo Gown & Hat Set—designed to perfectly coordinate with our Labor & Delivery Gowns. Featuring soft bamboo fabric and a gentle stretch, this gown is not only cozy but functional with a button accent and a convenient tie-bottom for quick diaper changes. Choose from three timeless colors:\n\n * Pink: Ultra-soft 210 GSM bamboo for a luxurious feel \n * Blue & Green: 70% bamboo, 25% organic cotton, 5% spandex blend for breathability and stretch \nA sweet, thoughtful gift for new parents, this set combines softness, style, and practicality for your newborn’s first days.\n",
  tags: [],
  msrpDollars: 30,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:07.148Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
